import React from "react";

const ExclamationSvg = () => {
  return (
    <svg
      width="63"
      height="103"
      viewBox="0 0 63 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="87" r="16" fill="#FFA686" />
      <path
        d="M23 61C27 43 36.5 26 47 16"
        stroke="#CFB2FF"
        strokeWidth="32"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ExclamationSvg;
